export default __webpack_public_path__ + "static/media/bergen_bryggen2.0a424a5f.jpg";